import React, {useEffect} from 'react';
import EyeDrop from '../assets/SVG/icons/eye-drop.png';
import AgeIcon from '../assets/SVG/icons/age-icon.png';
import EyeLaser from '../assets/SVG/icons/laser-icon.png';
import Warning from '../assets/SVG/icons/warning.svg';
import Header from '../components/Header';
import '../styles/contraindications.css';

export default function Contraindications(props) {

    useEffect(() => {
        document.title = "Contraindications";
    }, []);

    function handleClick() {
        props.history.push({ 
            pathname: '/beforetest',
            state: { isDemo: props?.location?.state?.isDemo }
        });
    }

    return (
        <div className="container">
            <div className="main contraindications">
                <Header/>
                <div className='heading mt-3'>
                    <p>
                        <u>Do not</u> use this test if you have:
                    </p>
                </div>
                <div className='wrapper'> 
                    <img src={Warning} alt='warning' />                  
                    <div className="info">
                        <img src={AgeIcon} alt="light"/> <p>Do not use on anyone under the age of 18.</p>
                    </div>
                    <div className="info">
                        <img src={EyeDrop} alt="light"/> <p>Do not use if you have used eye drops or ointment in the last 30 minutes(except artificial tears).</p>
                    </div>
                    
                    <div className="info">
                        <img src={EyeLaser} alt="light"/> <p>Do not use if you have had eye surgery or corneal trauma in the last 12 months.</p>
                    </div>
                </div>
                {props.location.state ? 
                    <div className='mb-5'>
                        <button id='understand' onClick={handleClick}>I understand</button>
                    </div>
                    : <></>
                }
            </div>
        </div>
    )
}

